import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { Selector } from '@leverege/ui-elements';
import { TextInput, Flex, LabelGroup, InsetSection, JsonEditorDialog, Section } from '~/views';

import style from './style.css'
import { registry } from './Factory'

export default class PublishTopicEditor extends React.Component {
  static TYPE = 'publishTopic';

  static NAME = 'Publish Topic';

  static DEFAULTS = {
    type : 'publishTopic',
    topic : 'someTopic',
    message : { }
  }

  constructor( props ) {
    super( props )
    this.state = {
      showDialog : false
    }
  }

  changePath = ( path, value, err ) => {
    if ( err ) {
      console.log( `error setting ${path} to ${value}`, err )
      this.props.onError( path, value, err )
      return
    }
    if ( typeof this.props.onChange === 'function' ) {
      this.props.onChange( { target : this.props.timer, path, value } );
    }
  }

  render() {
    // this.baseTimer.changePath( 'timer/when', v, err )
    const { timer } = this.props
    const { showDialog } = this.state
    const actionObj = timer.action

    const types = Object.keys( registry ).map( ( value ) => {
      return { value, name : registry[value].NAME }
    } )

    return (
      <div>
        <Section title="Action">
          <Flex variant="vSpace" align="stretch" direction="column">
            <LabelGroup>
              <label>Type</label>
              <Selector
                values={types}
                value={actionObj.type}
                onChange={( value ) => { this.changePath( 'action/type', value.value, false ); }} />
            </LabelGroup>
            <LabelGroup>
              <label>Topic</label>
              <TextInput
                value={actionObj.topic}
                onChange={( value ) => { this.changePath( 'action/topic', value, false ); }} />
            </LabelGroup>
            <LabelGroup vertical>
              <label>Message</label>
              <InsetSection style={{ width : '100%' }}>
                <div className={actionObj.message ? style.metadata : style.noMetadata}>{ ( actionObj.message && JSON.stringify( actionObj.message ) ) || 'No Message' }</div> 
                <Button style={{ float : 'right' }} bsSize="sm" onClick={() => { this.setState( { showDialog : true } ) }}>Edit</Button>
              </InsetSection>
            </LabelGroup>
          </Flex>
          <JsonEditorDialog 
            title="Action Message"
            message="Enter the JSON object for the actions message"
            show={showDialog} 
            onOk={( val ) => { 
              console.log( val )
              this.changePath( 'action/message', val, false )
              this.setState( { showDialog : false } ) 
            }}
            onCancel={() => { this.setState( { showDialog : false } ) }}
            value={actionObj.message} />
        </Section>
      </div>
    )
  }
}
